import fetch from '@/plugin/axios'

// 添加活动
export function getAddCRAct (query) {
  return fetch({
    url: '/api/order/appoint/add',
    method: 'Post',
    data: query
  })
}

// 活动列表
export function getCRList (query) {
  return fetch({
    url: '/api/order/appoint/list',
    method: 'Post',
    data: query
  })
}
// 上架活动
export function getCrUp (id) {
  return fetch({
    url: `/api/order/appoint/up/${id}`,
    method: 'Get'
  })
}
// 下架活动
export function getCRDown (id) {
  return fetch({
    url: `/api/order/appoint/down/${id}`,
    method: 'Get'
  })
}
// 活动信息
export function getCRInfo (id) {
  return fetch({
    url: `/api/order/appoint/info/${id}`,
    method: 'Get'
  })
}
// 修改活动
export function getCRUpdate (query, id) {
  return fetch({
    url: `/api/order/appoint/update/${id}`,
    method: 'Post',
    data: query
  })
}
// 赠送机会券
export function getSendTicket (query) {
  return fetch({
    url: '/api/order/appoint/send-ticker',
    method: 'Post',
    data: query
  })
}
// 卡片列表
export function getCard (id) {
  return fetch({
    url: `/api/order/appoint/card/${id}`,
    method: 'Get'
  })
}
// 增加库存
export function getStock (id, query) {
  return fetch({
    url: `/api/order/appoint/card/stock/${id}`,
    method: 'Post',
    params: query
  })
}

// 记录列表
export function getLogList (query) {
  return fetch({
    url: '/api/order/appoint-log/list',
    method: 'Post',
    data: query
  })
}
// 卡片列表导出
export function getCardExel (id) {
  return fetch({
    url: `/api/order/appoint/card/exel/${id}`,
    method: 'Get',
    headers: {
      'Content-Type': 'application/vnd.ms-excel,charset=utf-8'
    },
    responseType: 'blob'
  })
}
